const EMAIL_ADDRESS_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MAX_EMAIL_LENGTH = 254;

export function isValidEmailAddress(value: string): boolean {
  const normalizedValue = value.trim();

  return normalizedValue.length > 0
    && normalizedValue.length <= MAX_EMAIL_LENGTH
    && EMAIL_ADDRESS_PATTERN.test(normalizedValue);
}
